<template>
  <ReportSection
    background="--jcWhite"
    :columns="2"
    data-test-id="ValueReport__overviewCard"
    hasLargeHeading
    title="Overview"
  >
    <ParagraphBody
      v-for="(stat, index) in metrics"
      :key="`overview-stat-${index}`"
      bodySize="large"
      :class="$style.stat"
    >
      <span>{{ stat.label }}</span>
      <span>{{ stat.value }}</span>
    </ParagraphBody>
  </ReportSection>
</template>

<script>
import { ParagraphBody } from '@jumpcloud/ui-components';

import ReportSection from './ReportSection.vue';

export default {
  name: 'OverviewCard',

  components: {
    ReportSection,
    ParagraphBody,
  },

  props: {
    metrics: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style module scoped>
  .stat {
    display: flex;
    justify-content: space-between;
  }
</style>
